import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ExternalLink, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useThemeEffect } from "@/hooks/use-theme";
import { EnhancedHeader } from "@/components/ui";

export default function AboutPage() {
  // Apply theme when component mounts
  useThemeEffect();

  return (
    <div>
      {/* Mobile-friendly navigation header */}
      <EnhancedHeader
          title="About Spar Legends"
          backPath="/user-settings"
          coloredText={true}
          rightContent={null}
          showBackButton={true}
        />
      <div className="min-h-screen themed-gradient text-white p-6">
      
      <div className="max-w-2xl mx-auto">
        <div className="theme-card p-6">
          <div className="mb-6 text-center">
            <Badge className="mb-4 bg-blue-600/20 text-blue-300 border border-blue-500/40 px-3 py-1 text-sm">
              <ShieldCheck className="h-4 w-4 mr-2" /> Beta Version
            </Badge>
            <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-primary mb-2">
              Spar Legends
            </h1>
            <p className="text-gray-400">The ultimate card gaming platform</p>
          </div>

          <Separator className="my-6 bg-white/10" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h2 className="text-xl font-bold mb-4">About the Platform</h2>
              <p className="text-gray-300 mb-4">
                Welcome to our gaming universe! We're currently shuffling the
                cards and leveling up this platform with exciting new features.
              </p>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-start">
                  <span className="h-5 w-5 text-green-400 mr-2">✓</span>
                  Multiplayer card games
                </li>
                <li className="flex items-start">
                  <span className="h-5 w-5 text-green-400 mr-2">✓</span>
                  Custom deck designs
                </li>
                <li className="flex items-start">
                  <span className="h-5 w-5 text-green-400 mr-2">✓</span>
                  Tournaments and leaderboards
                </li>
                <li className="flex items-start">
                  <span className="h-5 w-5 text-yellow-400 mr-2">→</span>
                  Advanced AI opponents (coming soon)
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Technical Information</h2>
              <div className="space-y-3 text-gray-300">
                <div className="flex justify-between">
                  <span className="text-gray-400">Version:</span>
                  <span>Spar Legends Beta 1.3.2</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Updated:</span>
                  <span>May 27, 2025</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Status:</span>
                  <Badge className="bg-green-500/20 text-green-400 border-0">
                    Online
                  </Badge>
                </div>

                <Button
                  variant="outline"
                  size="sm"
                  className="mt-4 w-full bg-primary/10 border-primary/30 hover:bg-primary/20 text-white"
                  asChild
                >
                  <Link to="/changelog">
                    View Changelog <ExternalLink className="ml-2 h-3 w-3" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          <Separator className="my-6 bg-white/10" />

          <div className="text-center text-gray-400 text-sm">
            <p>Contact the Game Master at dev@sparlegends.com</p>
            <p className="mt-2">© 2025 Spar Legends. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  );
}
